import React from "react";

/**
 * NiftySky brand logo — renders the user's official /final-logo.png.
 * `size` controls the rendered height in px; width auto-scales.
 */
interface BrandLogoProps {
  size?: number;
  className?: string;
  priority?: boolean;
}

const BrandLogo: React.FC<BrandLogoProps> = ({ size = 28, className = "" }) => {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src="/final-logo.png"
      alt="NiftySky"
      className={`ns-logo select-none ${className}`}
      style={{ height: size, width: "auto", display: "block", flexShrink: 0 }}
      draggable={false}
    />
  );
};

export default BrandLogo;
